import { mode } from '@chakra-ui/theme-tools';
const Card = {
	baseStyle: (props: any) => ({
		p: '20px',
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		position: 'relative',
		borderRadius: '24px',
		minWidth: '0px',
		wordWrap: 'break-word',
		bg: mode('rgba(255,255,255,0.92)', 'rgba(15,23,42,0.82)')(props),
		backdropFilter: 'blur(18px)',
		border: '1px solid',
		borderColor: mode('rgba(148,163,184,0.20)', 'rgba(148,163,184,0.18)')(props),
		boxShadow: mode(
			'0 18px 46px rgba(15, 23, 42, 0.10)',
			'0 24px 70px rgba(2, 6, 23, 0.32)'
		)(props),
		backgroundClip: 'border-box',
		transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
		_hover: {
			transform: 'translateY(-2px)',
			borderColor: mode('rgba(99,102,241,0.26)', 'rgba(99,102,241,0.34)')(props),
			boxShadow: mode(
				'0 24px 60px rgba(15, 23, 42, 0.14)',
				'0 30px 86px rgba(2, 6, 23, 0.42)'
			)(props),
		}
	})
};

export const CardComponent = {
	components: {
		Card
	}
};
